import api from "./api";

const SW_PATH = "/push-sw.js";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return new Uint8Array([...raw].map((c) => c.charCodeAt(0)));
}

export async function isPushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export async function getPushStatus() {
  if (!(await isPushSupported())) return "unsupported";
  if (Notification.permission === "denied") return "denied";
  try {
    const reg = await navigator.serviceWorker.getRegistration(SW_PATH);
    if (!reg) return "not_subscribed";
    const sub = await reg.pushManager.getSubscription();
    return sub ? "subscribed" : "not_subscribed";
  } catch {
    return "not_subscribed";
  }
}

export async function subscribePush() {
  if (!(await isPushSupported())) throw new Error("Push not supported by this browser");
  // Request permission
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission denied — enable notifications in your browser settings");
  // Register SW
  const reg = await navigator.serviceWorker.register(SW_PATH);
  await navigator.serviceWorker.ready;
  // Fetch VAPID public key
  const { data } = await api.get("/push/public-key");
  if (!data.public_key) throw new Error("Server VAPID public key missing");
  const appServerKey = urlBase64ToUint8Array(data.public_key);
  // Subscribe (or get existing)
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: appServerKey });
  }
  // Send to backend
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return sub;
}

export async function unsubscribePush() {
  const reg = await navigator.serviceWorker.getRegistration(SW_PATH);
  if (!reg) return;
  const sub = await reg.pushManager.getSubscription();
  if (!sub) return;
  await api.post("/push/unsubscribe", { endpoint: sub.endpoint });
  await sub.unsubscribe();
}

export async function sendTestPush() {
  await api.post("/admin/push/test");
}
